import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/Legal.css";

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="logo" onClick={() => navigate("/")}>
        TOEICMON
      </div>

      <div className="legal-content">
        <div className="legal-header">
          <h1>이용 약관</h1>
          <p>최종 업데이트: 2024년 5월 1일</p>
        </div>

        <div className="legal-sections">
          <section className="legal-section">
            <h2>1. 약관 동의</h2>
            <p>
              토익몬의 웹사이트와 서비스를 이용함으로써 귀하는 이 이용 약관에
              동의하게 됩니다. 이 약관에 동의하지 않으시면 서비스 이용을 중단해
              주시기 바랍니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. 사용자 계정</h2>
            <p>
              2.1. 서비스 이용을 위해 계정을 생성해야 합니다. 계정 정보의 기밀
              유지는 사용자의 책임입니다.
            </p>
            <p>
              2.2. 계정 생성 시 정확하고 완전한 정보를 제공하고, 필요에 따라 이
              정보를 업데이트하는 데 동의합니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. 이용권 및 결제</h2>
            <p>
              3.1. 토익몬 서비스 이용을 위해서는 한달 이용권 구매가 필요합니다.
              이용권 가격은 구매 전 명확하게 표시됩니다.
            </p>
            <p>
              3.2. 한달 이용권은 구매일로부터 30일간 유효하며, 자동 갱신되지
              않습니다.
            </p>
            <p>3.3. 환불은 당사의 환불 정책에 따라 제공됩니다.</p>
          </section>

          <section className="legal-section">
            <h2>4. 사용자 행동</h2>
            <p>
              4.1. 계정 정보나 이용권 접근 권한을 타인과 공유하지 않는 데
              동의합니다.
            </p>
            <p>
              4.2. 플랫폼의 콘텐츠를 복사, 배포 또는 역설계하지 않는 데
              동의합니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. 지적 재산권</h2>
            <p>
              5.1. 문제, 설명 및 학습 자료를 포함한 토익몬의 모든 콘텐츠는
              저작권 및 기타 지적 재산권에 의해 보호됩니다.
            </p>
            <p>
              5.2. 명시적 허가 없이 상업적 목적으로 당사 콘텐츠를 사용할 수
              없습니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. 책임의 제한</h2>
            <p>
              6.1. 토익몬은 학습 자료와 모의 테스트를 제공하지만 특정 시험
              점수나 결과를 보장하지 않습니다.
            </p>
            <p>
              6.2. 당사는 서비스 사용 또는 사용 불능으로 인해 발생하는 어떠한
              손해에 대해서도 책임을 지지 않습니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. 약관 변경</h2>
            <p>
              당사는 언제든지 이 약관을 수정할 권리를 보유합니다. 중요한 변경
              사항은 이메일이나 웹사이트 공지를 통해 사용자에게 알립니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. 문의하기</h2>
            <p>
              이 이용 약관에 대해 질문이 있으시면 support@toeicmon.com으로
              문의해 주세요.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;
